import {
  ThemedFunctor, getSpacing, SpacingName, getTypography, TypographyName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const article = css`
  position: relative;
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
`;

export const anchor = css`
  position: absolute;
  // Trick to avoid that the article block is covered by the main navigation
  top: -6rem;
`;
